import React from "react";
import { useSelector } from "react-redux";
import { WifiOff } from "lucide-react";
import { selectIsOffline } from "../redux/slices/networkSlice";

export default function NetworkStatusBanner() {
  const isOffline = useSelector(selectIsOffline);

  if (!isOffline) return null;

  return (
    <div className="network-banner" role="alert" aria-live="polite">
      <WifiOff size={13} aria-hidden />
      <span>Offline</span>
    </div>
  );
}
